<template>
  <div :class="['st-dropdown', { 'st-dropdown--disabled': disabled }]" ref="st-dropdown">
    <div class="st-dropdown-input" :class="{ 'disabled': disabled }" @click="toggleDropdown" onclick="this.setAttribute('value', this.value);">
      <div class="st-dropdown-label-container">
        <label class="st-dropdown-label" :class="{ 'floating': isOpen || selectedOption }">{{ label }}</label>
        <span v-if="selectedOption" class="pt-2">{{ selectedOption.label }}</span>
      </div>
      <div class="st-dropdown-icon">
        <img v-if="selectedOption && selectedOption.logo != null" :alt="`${selectedOption.label}`" class="bank-icon" :src="`/img/banks/${selectedOption.logo}`">
        <i class="sr sr-chevron-down"></i>
      </div>
    </div>
    <div v-if="isOpen" class="st-dropdown-menu">
      <div v-for="option in options" :key="option.id" class="st-dropdown-item" @click="selectOption(option)">
        <img v-if="option.logo" :src="`/img/banks/${option.logo}`" alt="option image" class="option-image">
        {{ option.label }}
      </div>
    </div>
    <p v-if="error" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    value: null,
    label: {
      type: String,
      required: true
    },
    options: Array,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: "энэ нүдийг бөглөнө үү"
    }
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null
    };
  },
  methods: {
    syncSelectedOption() {
      if (this.value == null) {
        this.selectedOption = null;
        return;
      }

      this.selectedOption = this.options?.find(option => option.id === this.value) ?? null;
    },
    toggleDropdown() {
      if (!this.disabled){
        this.isOpen = !this.isOpen;
      }
    },
    selectOption(option) {
      if (!this.disabled) {
        this.selectedOption = option;
        this.$emit('input', option.id);
        this.isOpen = false;
        console.log(this.selectedOption)
      }
    },
    handleClickOutside(event) {
      if (this.$refs["st-dropdown"] && !this.$refs["st-dropdown"].contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  watch: {
    value() {
      this.syncSelectedOption();
    },
    options: {
      handler() {
        this.syncSelectedOption();
      },
      deep: true,
    },
  },
  mounted() {
    this.syncSelectedOption();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.st-dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom:20px;
}

.st-dropdown--disabled {
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom:20px;
  cursor: not-allowed;
}

.st-dropdown-label {
  color: var(--gray-color-new);
  font-size:14px;
  font-weight:400;
  position:absolute;
  pointer-events:none;
  left:15px;
  top:15px;
  padding:0 5px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}

.st-dropdown-label.floating {
  top:7px;
  font-size:11px;
}

.st-dropdown-input {
  display: flex;
  justify-content: space-between;
  background: var(--gray-color-10-new);
  border-radius: 6px;
  padding: 20px;
  height: 54px;
  border: none;
  cursor: pointer;
  span {
    font-size:14px;
    font-weight: 400;
    color: var(--primary-color-new);
  }
}

.st-dropdown-icon {
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  i {
    color: var(--primary-color-new);
  }
}

.bank-icon {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  margin-right: 20px;
  object-fit: cover;
}

.st-dropdown-menu {
  position: absolute;
  display: block;
  max-height: 400px;
  overflow-y: scroll;
  left: 0;
  right: 0;
  border: 1px solid var(--gray-color-10-new);
  background-color: var(--white-or-dark-color);
  z-index: 10;
}

.st-dropdown-item {
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  color: var(--primary-color-new);
}

.st-dropdown-item:hover {
  background-color: var(--gray-color-10-new);
}

.option-image {
  margin-right: 10px;
  border-radius: 7px;
  object-fit: cover;
  width: 20px;
  height: 20px;
}
</style>
